import { RouteObject } from 'react-router-dom';
import ListWrestlersResponsive from "../components/ResponsiveWrapper/ListWrestlersResponsive";
import { ListWrestlersResponsiveLoader } from "../loaders/ListWrestlersResponsiveLoader";
import SingleWrestlerResponsive from "../components/ResponsiveWrapper/SingleWrestlerResponsive";
import { WrestlerResponsiveLoader } from "../loaders/WrestlerResponsiveLoader";

export const wrestlersRoutes: RouteObject = {
  path: 'wrestlers',
  children: [
    {
      index: true,
      element: <ListWrestlersResponsive />,
      loader: ListWrestlersResponsiveLoader
    },
    {
      path: ':idString',
      element: <SingleWrestlerResponsive />,
      loader: WrestlerResponsiveLoader
    },
  ]
};
